import type { CssGeneratorContext } from '../css-generator.model';

export const styles = ({ dt }: CssGeneratorContext) => `
.app-surface { background-color: ${dt('appSurface.background')}; }
.app-surface-subtle { background-color: ${dt('appSurface.subtle.background')}; }
.app-surface-muted { background-color: ${dt('appSurface.muted.background')}; }
.app-surface-neutral { background-color: ${dt('appSurface.neutral.background')}; }
.app-surface-highlight { background-color: ${dt('appSurface.highlight.background')}; }
@media (hover: hover) {
  .app-surface-highlight-hover:hover { background-color: ${dt('appSurface.highlight.hoverBackground')}; }
}
.app-surface-success { background-color: ${dt('appSurface.success.background')}; }
.app-border { border-color: ${dt('appSurface.border.color')}; }
.app-border-subtle { border-color: ${dt('appSurface.border.subtleColor')}; }
`;
